import { __t } from '@/lib/helpers.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'

export default {
  path: 'personal',
  name: 'settings-personal',
  meta: {
    title: __t('routes.settings.personal.title'),
    subtitle: __t('routes.settings.personal.subtitle'),
    icon: 'personal-settings',
    backgroundIcon: 'personal',
  },
  component: () => import('@/views/business/settings/personal/index.vue'),
  children: [
    {
      path: 'notifications',
      name: 'settings-personal-notifications',
      meta: {
        title: __t('routes.settings.personal.notifications.title'),
        subtitle: __t('routes.settings.personal.notifications.subtitle'),
        [ROUTE_META_PARAMS.HIDDEN_IN_PRODUCTION]: true,
      },
      component: () => import('@/views/business/settings/personal/notifications/index.vue'),
    },
    {
      path: 'select-business',
      name: 'settings-personal-select-business',
      meta: {
        title: __t('routes.settings.personal.select-business.title'),
        subtitle: __t('routes.settings.personal.select-business.subtitle'),
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE] (store) {
          const { business, app } = store.state
          return app.mode === 'development' || business.businessesCount > 1
        },
      },
      component: () => import('@/views/business/settings/personal/select-business/index.vue'),
    },
    {
      path: 'language',
      name: 'settings-personal-language',
      meta: {
        title: __t('routes.settings.personal.language.title'),
        subtitle: __t('routes.settings.personal.language.subtitle'),
      },
      component: () => import('@/views/business/settings/personal/language/index.vue'),
    },
    {
      path: 'performance',
      name: 'settings-personal-performance',
      meta: {
        title: __t('routes.settings.personal.performance.title'),
        subtitle: __t('routes.settings.personal.performance.subtitle'),
      },
      component: () => import('@/views/business/settings/personal/performance.vue'),
    },
    {
      path: 'sign-in-methods',
      name: 'settings-personal-sign-in-methods',
      meta: {
        title: __t('routes.settings.personal.sign-in-methods.title'),
        subtitle: __t('routes.settings.personal.sign-in-methods.subtitle'),
      },
      component: () => import('@/views/business/settings/personal/sign-in-methods/index.vue'),
    },
    {
      path: 'logout',
      name: 'settings-personal-logout',
      meta: {
        title: __t('routes.settings.personal.logout.title'),
        subtitle: __t('routes.settings.personal.logout.subtitle'),
        [ROUTE_META_PARAMS.DARK]: true,
        [ROUTE_META_PARAMS.RIGHT_ICON]: 'logout',
      },
      component: () => import('@/views/business/settings/personal/logout.vue'),
    },
  ],
}
